import React from "react";
import PageLayout from "./PageLayout";
import TopAdSlider from "./TopAdSlider";
import HeroSection from "./HeroSection";
import DiagnosticSection from "./DiagnosticSection";
import ContactSection from "./ContactSection";
import usePageMeta from "../hooks/usePageMeta";

const LandingPage = () => {
  usePageMeta({
    title: "RG Servicio Técnico | Diagnóstico interactivo y reparación de PC",
    description:
      "Servicio técnico especializado en PC, notebooks, consolas y celulares. Diagnóstico interactivo, planes y soporte profesional en Lincoln, Buenos Aires.",
    canonical: "https://rgserviciotecnico.com/"
  });

  return (
    <PageLayout className="bg-background">
      <TopAdSlider />
      <HeroSection />
      <DiagnosticSection sectionId="diagnostico" />
      <ContactSection />
    </PageLayout>
  );
};

export default LandingPage;
